// Helpers for the account email link pages (components/AccountLinkPage.jsx).

// Which page an email link opens, from the URL path; null for anything else.
export function accountLinkKind(pathname) {
  if (pathname === "/reset-password") return "reset";
  if (pathname === "/verify-email") return "verify";
  return null;
}

// FastAPI returns validation failures (e.g. a weak password) as a list.
export function errorMessage(data, fallback) {
  const d = data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error,\s*/, "");
  return fallback;
}
